









































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import ky from 'ky'
import { RelativePayload } from '@/api/user/types'
import { Route } from 'vue-router'

@Component
export default class RelativeIndex extends Vue {
  $store!: ExStore
  inputs = {
    ...(this.$store.getters['user/sessionData'](
      'newRelative'
    ) as RelativePayload)
  }
  pending = false

  created() {
    if (!this.inputs) {
      console.error('Invalid session')
      this.$router.push({ name: 'PatientRelative' })
      return
    }
  }

  async submit() {
    if (this.pending) {
      return
    }
    this.pending = true
    try {
      if (this.inputs.id) {
        await this.$api.user.patchRelative({
          relativeId: this.inputs.id,
          payload: this.inputs
        })
        this.$router.push({
          name: 'PatientRelative'
        })
        return
      }
      const relative = await this.$api.user.createRelative(this.inputs)
      this.$store.commit('user/setSessionData', {
        createdRelative: relative
      })
      this.$router.push({
        name: 'PatientRelativeComplete'
      })
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const errors = await e.response.json()
        this.$store.dispatch('alert/showErrorResponse', errors)
        return
      }
      console.error(e)
    } finally {
      this.pending = false
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: (allow?: boolean) => void) {
    if (to.name !== 'PatientRelativeAdd') {
      this.$store.commit('user/deleteSessionData', 'newRelative')
    }
    next()
  }
}
